<template>
  <div>
    <v-container class="grey lighten-5">
      <v-form ref="useForm" v-model="valid" lazy-validation>
        <v-container>
          <v-row>
            <v-col cols="12" md="3">
              <v-select
                v-model="selectValue"
                :items="items"
                :rules="[v => !!v || 'Item is required']"
                label="Select Category"
                required
                @input="emptyValue(selectValue)"
                name="userProfile"
                id="userProfile"
              ></v-select>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-if="selectValue=='Mobile Number'"
                v-model="mobileNo"
                :rules="mobileRules"
                label="Mobile No."
                required
              ></v-text-field>

              <v-text-field
                v-if="selectValue=='UUID Number'"
                :rules="uidRules"
                label="UIN No."
                required
                v-model="uidNo"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-btn v-if="!openProfile" color="primary" class="mr-4 mt-4" @click="submit()">Submit</v-btn>

              <div v-if="openProfile" class>
                <v-btn
                  :disabled="!valid"
                  color="error"
                  class="mr-4 mt-4"
                  @click="clearData()"
                >Clear Data</v-btn>
              </div>
            </v-col>

            <v-col cols="12" md="3">
              <!-- <v-btn color="error" class="mr-4" @click="reset">Reset Form</v-btn>
              <v-btn color="warning" @click="resetValidation">Reset Validation</v-btn>-->
              <!-- <label for>Category</label>
              <select name id class="form-control" v-model="forRole">
                <option value="patient">Patient</option>
                <option value="doctor">Doctor</option>
              </select>-->
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <h4 v-if="errorMsg" class="text-center">User Not Found</h4>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="4">
            <v-skeleton-loader
              v-if="isLoading"
              v-bind="attrs"
              type="list-item-avatar-three-line,  article"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>

      <v-card v-if="openProfile" class="mx-auto user-card-section" max-width="600">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline mb-1">User Details</v-list-item-title>
            <v-card-text>
              <p>
                <span class="font-weight-bold">Name:</span>
                {{profileData.full_name}}
              </p>
              <p>
                <span class="font-weight-bold">Gender:</span>
                {{profileData.gender}}
              </p>
              <p>
                <span class="font-weight-bold">Age:</span>
                {{profileData.age}}
              </p>
              <p>
                <span class="font-weight-bold">DOB:</span>
                {{ (profileData.dob) ? dayJS(profileData.dob).format(formats.date_format) : ""}}
              </p>
              <p>
                <span class="font-weight-bold">UUID:</span>
                {{profileData.uuid}}
              </p>
              <p>
                <span class="font-weight-bold">Address:</span>
                {{ (profileData.address && profileData.address.current_address && profileData.address.current_address.address_line_two) ? profileData.address.current_address.address_line_two : ""}}
              </p>
              <p>
                <span class="font-weight-bold">Roll:</span>
                <span class="ml-2" v-for="role in profileData.roles" :key="role">
                  <v-chip @click="openRole(role)" small color="yellow">{{role }}</v-chip>
                </span>
              </p>
              <p>
                <span class="font-weight-bold">Rating:</span>
                <starRating :rating="profileData.rating_as_patient.average_rating"></starRating>
                <!-- <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <span dark v-on="on">
                      &nbsp;
                      <b>
                        {{
                        profileData.rating_as_patient.total_reviews
                        }}
                      </b>&nbsp;
                    </span>&nbsp;
                  </template>
                  <span>Reviews</span>
                </v-tooltip>-->
              </p>
              <p>
                <v-btn @click="openRaiseRequest(profileData)" class="request-btn" text>Raise request</v-btn>
              </p>
            </v-card-text>
          </v-list-item-content>

          <v-list-item-avatar class="avtar-img" tile size="80" color="grey">
            <image-view :src="'/img/avatars/default-user.png'"></image-view>
          </v-list-item-avatar>
        </v-list-item>
      </v-card>

      <role-modal></role-modal>
      <profileFormModal :profileData="myData"></profileFormModal>
    </v-container>

    <div class="col-sm-12 row ml-0 p-0" v-if="openProfile">
      <div class="form-group col-sm-12" v-if="forRole == 'patient'">
        <PatientProfile :data="profileData" />
      </div>
      <div class="form-group col-sm-12" v-if="forRole == 'doctor'">
        <DoctorProfile :list="centerList" :data="profileData" />
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
import PatientProfile from "./PatientProfile";
import DoctorProfile from "./DoctorProfile";
import roleModal from "@/components/modals/roleModal.vue";
import profileFormModal from "@/components/modals/profileFormModal.vue";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import formats from "@/formats";
import starRating from "@/views/dashboardNew/starRating";
const Image = () => import("@/components/image.vue");

export default {
  components: {
    "image-view": Image,
  },
  data() {
    return {
      myDemoData: [],
      valid: true,
      name: "",
      mobileRules: [
        (v) => !!v || "Mobile no is required",
        (v) => (v && v.length <= 10) || "NO be less than 10 ",
      ],
      uidRules: [(v) => !!v || "UUID is required"],
      select: null,
      items: ["Mobile Number", "UUID Number"],
      isLoading: false,
      errorMsg: false,
      selectValue: "Mobile Number",
      mobileNo: "", //"8655302830",
      uidNo: "",
      pin: "",
      name: "",
      userMobile: "",
      email: "",
      category: "",
      subject: "",
      description: "",
      ticketModal: false,
      options: ["query", "suggestion", "feedback", "complaint"],
      openProfile: false,
      profileData: {},
      myData: {},
      forRole: "Mobile Number",
      centerList: [],
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      dayJS,
      formats,
      myData: {},
    };
  },
  // computed: {
  //   roleModalOpen() {
  //     return this.$store.state.ganeral.openRoleDialog;
  //   }
  // },

  components: {
    PatientProfile,
    DoctorProfile,
    roleModal,
    profileFormModal,
    starRating,
    "image-view": Image,
  },
  methods: {
    // validate() {
    //   this.$refs.form.validate();
    // },
    // reset() {
    //   this.$refs.form.reset();
    // },
    // resetValidation() {
    //   this.$refs.form.resetValidation();
    // },
    openRole(data) {
      const sendData = {
        role: data,
        roleDialog: true,
      };
      this.$store.commit("general/setModal", sendData);
    },
    openRaiseRequest(data) {
      this.myData = data;
      const sendUserData = {
        userData: data,
        roleDialog: true,
      };
      this.$store.commit("general/setProfileFormModal", sendUserData);
    },
    emptyValue(data) {
      this.$refs.useForm.resetValidation();
      this.openProfile = false;
      this.profileData = {};
      this.centerList = [];
      this.mobileNo = "";
      this.pin = "";
      this.forRole = "";

      if (data === "UUID Number") {
        this.uidNo = "";
      } else {
        this.mobileNo = "";
      }
    },
    clearData() {
      this.$refs.useForm.resetValidation();
      this.openProfile = false;
      this.profileData = {};
      this.centerList = [];
      this.mobileNo = "";
      this.pin = "";
      this.forRole = "";
    },
    submit() {
      this.$refs.useForm.validate();
      if (this.$refs.useForm.validate()) {
        this.isLoading = true;
        let obj = {};
        if (this.selectValue === "Mobile Number") {
          obj.mobile = this.mobileNo;
        } else {
          obj.uuid = this.uidNo;
        }
        // let obj = {
        //   mobile: this.mobileNo,
        //   secret_pin: this.uidNo
        // };
        let url = `${config.BASE_URL}api/v2/admin/users/details`;
        this.$http.post(url, obj).then((response) => {
          if (response.body.status) {
            this.isLoading = false;
            this.openProfile = true;
            this.profileData = response.body.data.userDetails;
            this.centerList = response.body.data.centers_list;
            this.errorMsg = false;
          } else {
            this.isLoading = false;
            this.errorMsg = true;
          }
        });
      }
    },
    submitForm() {
      let obj = {
        user_name: this.name,
        mobile: this.userMobile,
        email: this.email,
        description: this.description,
        subject: this.subject,
        ticket_type: this.category,
        // assigned_team: reqBody.assigned_team,
        created_by: this.userDetails ? this.userDetails._id : null,
        imageval: null,
      };
      let url = config.BASE_URL + "api/v2/user/ticket/create";
      this.$http.post(url, obj).then((response) => {
        if (response.body.status) {
          this.ticketModal = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.profile-info {
  .pro-info-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-items: inherit;
    .profile-info-list {
      width: 33.33%;
      display: flex;
      flex-direction: column;
      margin-bottom: 20px;
      svg {
        width: 25px;
        margin-right: 18px;
        path {
          fill: #3c4b64;
        }
      }
      h5 {
        margin: 0;
      }
      p {
        margin: 0;
      }
      &.address-card {
        width: 48%;
        border: 1px solid #ccc;
        padding: 13px;
        border-radius: 4px;
        margin-right: 15px;
      }
    }
  }
}

.btn-section {
  margin-top: 2.5rem;
}
.user-card-section {
  .avtar-img {
    background-color: #ddd;
  }
  .request-btn {
    background: #39f;
    color: #fff;
  }
}
</style>
